const today = new Date().getFullYear();

export const initialCategories = [
  `JAN/${today}`,
  `FEV/${today}`,
  `MAR/${today}`,
  `MAI/${today}`,
  `JUN/${today}`,
  `JUL/${today}`,
  `AGO/${today}`,
  `SET/${today}`,
  `OUT/${today}`,
  `NOV/${today}`,
  `DEZ/${today}`,
]

export const initialSeries = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
]
